<template>
  <mu-menu-item 
    :title='title'
    ref = 'menuItem'
    @click = 'onClick'
  >
    <mu-menu-item
      v-if = 'nestedItems.length > 0'
      :title = 'selectAllTitle'
      @click = 'onChooseAll'
    />
    <nest-menu-item
      v-for = 'nested of nestedItems'
      :title = 'nested.title'
      :selectAllTitle = 'selectAllTitle'
      :itemData = 'nested'
      :nestedItemVisitor = 'nestedItemVisitor'
      @choose-items = 'onChooseSubItems'
      ref = 'nestedItems'
    />
  </mu-menu-item>
</template>

<script>
export default {
  name: 'nest-menu-item',
  components: {
  },//end of components
  props: {
    title: {
    },
    selectAllTitle: {
    },
    nestedItemVisitor: {
      default: (x)=>((x)=>[]),
    },
    itemData: {
      default: ()=>({}),
    },
  }, //end of props
  data: ()=>({
  }),//end of data
  computed: {
    nestedItems: {
      get()
      {
        return this.nestedItemVisitor(this.itemData);
      },
    },
  }, //end of computed
  methods: {
    handleClick: function(ev)
    {
      return;
    },
    onChooseAll: function(ev)
    {
      this.$emit('choose-items', [this.itemData]);
      return;
    },
    onClick: function(ev)
    {
      if (this.nestedItems.length > 0)
      {
        return;
      }
      this.$emit('choose-items', [this.itemData]);
      return;
    },
    onChooseSubItems: function(subItems)
    {
      this.$emit('choose-items', [this.itemData].concat(subItems));
    }
  }, //end of method
  mounted: function ()
  {
  },
};
</script>



// WEBPACK FOOTER //
// component.vue?0a6c8810